import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslatePipe } from '@ngx-translate/core';
import { FavoriteViewFormComponent } from '../favorite-view-form/favorite-view-form.component';
import { FavoriteView, Filter } from '@iot-platform/models/common';
import { I4BGrid, I4BGridData, I4BGridOptions } from '@iot-platform/models/grid-engine';

@Component({
  imports: [MatCardModule, MatButtonModule, MatToolbarModule, TranslatePipe, MatIconModule, FavoriteViewFormComponent],
  selector: 'iot-platform-ui-favorite-view-form-dialog',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './favorite-view-form-dialog.component.html'
})
export class FavoriteViewFormDialogComponent {
  public data: { favoriteView: FavoriteView; filters: Filter[]; masterView: string; createForBusinessProfile: boolean } = inject(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<FavoriteViewFormDialogComponent>);

  save(result: { favoriteView: FavoriteView; grid: I4BGrid<I4BGridOptions, I4BGridData> | null }): void {
    this.dialogRef.close(result);
  }
}
